import { render, staticRenderFns } from "./default.vue?vue&type=template&id=f08db890"
import script from "./default.ts?vue&type=script&lang=js&external"
export * from "./default.ts?vue&type=script&lang=js&external"
import style0 from "./default.vue?vue&type=style&index=0&id=f08db890&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_webpack@4.47.0__css-loader@5.2.7_webpack@4.47.0___e99d8e97de94c5042a76fec31f8d8632/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports